// 내가 속한 조직들 — 사이드바 맨 위의 워크스페이스 이름과 전환 메뉴가 쓴다(3차 F31).
//
// 서버는 조직 목록을 **로그인할 때만** 준다(`memberships`, 신원 평면 — ADR 0007). 들어온 뒤의 주체에는 신원이
// 없어 다시 물을 문이 없다. 그래서 로그인 때 받은 목록을 이 기기에 적어 두고 새로 고친 뒤에도 쓴다. 적는 것은
// 조직 번호·주소·이름뿐이라 비밀이 아니고, 로그아웃하면 지운다 — 다음 사람에게 앞 사람의 조직이 보이면 안 된다.
// 목록이 없으면(이 기능 전에 로그인한 기기) 이름 단추를 그리지 않는다. 다음 로그인에 채워진다.

import type { Keeper } from '@maru/platform'

export const ORGS_KEY = 'maru.orgs'

export interface Org {
  tenant: number
  slug: string
  org_name: string
}

/** 한 칸씩 믿는다 — 모양이 틀린 칸만 버린다. */
export function read_orgs(raw: string | null): Org[] {
  if (raw === null) return []
  try {
    const list = JSON.parse(raw) as unknown
    if (!Array.isArray(list)) return []
    return list.flatMap((o: unknown) => {
      if (typeof o !== 'object' || o === null) return []
      const { tenant, slug, org_name } = o as Record<string, unknown>
      return typeof tenant === 'number' && typeof slug === 'string' && typeof org_name === 'string'
        ? [{ tenant, slug, org_name }]
        : []
    })
  } catch {
    return []
  }
}

export async function load_orgs(keep: Keeper): Promise<Org[]> {
  try {
    return read_orgs(await keep.get(ORGS_KEY))
  } catch {
    return []
  }
}

/** 로그인 때 받은 목록을 적는다. 역할 따위는 싣지 않는다 — 이름표에 쓸 것만. */
export async function keep_orgs(keep: Keeper, list: readonly Org[]): Promise<void> {
  try {
    const slim = list.map(({ tenant, slug, org_name }) => ({ tenant, slug, org_name }))
    await keep.put(ORGS_KEY, JSON.stringify(slim))
  } catch {
    // 이름 단추가 없을 뿐이다.
  }
}

export async function forget_orgs(keep: Keeper): Promise<void> {
  try {
    await keep.remove(ORGS_KEY)
  } catch {
    // 지울 것이 없었다.
  }
}
